
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/psychology-timed-communication-send-messages-when-matter-most",
      function () {
        return require("private-next-pages/article/psychology-timed-communication-send-messages-when-matter-most.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/psychology-timed-communication-send-messages-when-matter-most"])
      });
    }
  